module.exports = __webpack_public_path__ + "static/media/0328_LES_ENSEIGNES_LE_PRIMEUR_LETTRE_A_LETTRE.cf2c619e.webp";